import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import isNil from 'lodash/isNil';

const variants = {
    enter: ({ index  })=>({
            y: 0,
            opacity: 1,
            transition: {
                delay: index * 0.05,
                duration: 0.2,
                ease: 'easeIn'
            }
        })
    ,
    exit: {
        y: 10,
        opacity: 0
    }
};
var RadioButtonGroup = (_param)=>{
    var { initialValue , onChange , value  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "initialValue",
        "onChange",
        "value"
    ]);
    const initialSelectedValue = value ? value : initialValue;
    const [selectedValue, setSelectedValue] = React.useState(initialSelectedValue || '');
    const handleChange = React.useCallback((event)=>{
        const newSelectedValue = event.currentTarget.value;
        setSelectedValue(newSelectedValue);
        onChange(newSelectedValue);
    }, [
        onChange
    ]);
    React.useEffect(()=>{
        if (!isNil(value)) {
            setSelectedValue(value);
        }
    }, [
        value
    ]);
    const { items , scope , className , hasError  } = props;
    const classNames = classnames('radio-button-group', className);
    return /*#__PURE__*/ React.createElement("ul", {
        className: classNames,
        "data-t": props['data-t'],
        role: "radiogroup"
    }, /*#__PURE__*/ React.createElement(AnimatePresence, null, items.length > 0 && items.map((item, index)=>/*#__PURE__*/ React.createElement(motion.li, {
            className: "radio-button-group__item",
            key: item.value,
            custom: {
                index
            },
            variants: variants,
            initial: "exit",
            animate: "enter",
            role: "presentation"
        }, /*#__PURE__*/ React.createElement("div", {
            className: classnames('radio-button-group__container', {
                'radio-button-group__label--disabled': item.disabled,
                'radio-button-group__label--checked': item.value === selectedValue,
                'radio-button-group__label--error': hasError
            })
        }, /*#__PURE__*/ React.createElement("label", {
            className: classnames('radio-button-group__label', {
                'radio-button-group__label--disabled': item.disabled,
                'radio-button-group__label--checked': item.value === selectedValue,
                'radio-button-group__label--error': hasError
            })
        }, /*#__PURE__*/ React.createElement("input", {
            className: "radio-button-group__input",
            name: scope,
            "data-t": item.value,
            type: "radio",
            value: item.value,
            checked: item.value === selectedValue,
            "aria-checked": item.value === selectedValue,
            disabled: item.disabled,
            onChange: handleChange
        }), /*#__PURE__*/ React.createElement("div", {
            className: classnames('radio-button-group__radio', {
                'radio-button-group__radio--disabled': item.disabled,
                'radio-button-group__radio--checked': item.value === selectedValue,
                'radio-button-group__radio--error': hasError
            })
        }), /*#__PURE__*/ React.createElement("div", {
            className: "radio-button-group__text"
        }, /*#__PURE__*/ React.createElement("span", null, item.label), item.subtext && /*#__PURE__*/ React.createElement("span", {
            className: "radio-button-group__subtext"
        }, item.subtext)), item.aside && /*#__PURE__*/ React.createElement("span", {
            className: "radio-button-group__aside"
        }, item.aside)), item.content && item.value === selectedValue && /*#__PURE__*/ React.createElement("div", {
            className: classnames('radio-button-group__content', {
                'radio-button-group__label--disabled': item.disabled,
                'radio-button-group__label--checked': item.value === selectedValue,
                'radio-button-group__label--error': hasError
            })
        }, item.content)))
    )));
};

export { RadioButtonGroup };
//# sourceMappingURL=RadioButtonGroup.js.map
